export default {
  title: 'Bist du sicher?',
  description: 'Die folgenden Modifizierergruppen (einschließlich ihrer Modifikatoren) werden gelöscht:',
  buttons: {
    yes: 'Ja',
    no: 'Nein',
  },
  toasts: {
    modifier_group_got_deleted: 'Modifizierergruppen wurde gelöscht',
    failed_to_delete_modifier_group: 'Die Modifizierergruppe konnte nicht gelöscht werden',
  },
};
